import React, { useState, useEffect, useCallback } from 'react';
import { createPortal } from 'react-dom';

// Prints the original blank worksheet images, one per page (Print / Save as PDF).
export function usePrintSheets() {
  const [images, setImages] = useState(null);

  useEffect(() => {
    if (!images) return undefined;
    document.body.classList.add('fb-printing');
    const imgs = Array.from(document.querySelectorAll('.fb-print-root img'));
    const ready = Promise.all(imgs.map((im) => (im.complete ? Promise.resolve() : new Promise((r) => { im.onload = r; im.onerror = r; }))));
    const done = () => { document.body.classList.remove('fb-printing'); setImages(null); };
    window.addEventListener('afterprint', done, { once: true });
    ready.then(() => setTimeout(() => window.print(), 100));
    return () => { window.removeEventListener('afterprint', done); document.body.classList.remove('fb-printing'); };
  }, [images]);

  const print = useCallback((list) => setImages(list), []);
  const portal = images && createPortal(
    <div className="fb-print-root" data-testid="fb-print-root">
      {images.map((src) => (
        <div key={src} className="fb-print-page"><img src={src} alt="" /></div>
      ))}
    </div>,
    document.body,
  );
  return { print, portal };
}
